import { Navigate, useLocation } from "react-router-dom";
import useUserStore from "../stores/user-store";

const PublicOnlyRoutes = ({children}) => {
    const LoggedIn = useUserStore((state) => state.loggedIn);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const returnTo = searchParams.get("returnTo");
    
    return LoggedIn ? <Navigate to={returnTo && returnTo !== "" ? returnTo : "/"} replace /> : children;
}

export default PublicOnlyRoutes;
